module.exports = __webpack_public_path__ + "static/media/watchlist-w.72aecf49.svg";